import styles from './set-new-password-form.module.scss';
import { Button, FormikTextInputField } from '@spotted-zebra-uk/ui-components';
import { Formik, useField } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { useMemo } from 'react';
import { getPasswordValidation } from '@/utils/validation';

const initialValues = { password: '' };

type SetNewPasswordFormProps = {
  submitting: boolean;
  handlePasswordReset: (email: string) => void;
};

export const SetNewPasswordForm = ({
  submitting,
  handlePasswordReset,
}: SetNewPasswordFormProps) => {
  const { t } = useTranslation();

  const validationForm = useMemo(() => {
    return yup.object().shape({
      password: getPasswordValidation(t),
    });
  }, []);

  const onSubmit = (values: { password: string }) => {
    handlePasswordReset(values.password);
  };

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={validationForm}
    >
      {({ handleSubmit }) => (
        <form onSubmit={e => e.preventDefault()}>
          <FormikTextInputField
            id="password"
            type="password"
            label={t('setNewPassword.newPassword')}
            placeholder={t('setNewPassword.newPassword')}
            data-testid="set-new-password__password"
            useFormikField={useField}
          />
          <Button
            onClick={() => handleSubmit()}
            fullWidth
            className={styles.submitButton}
            disabled={submitting}
            type="submit"
            data-testid="set-new-password__confirm-button"
          >
            {t('common.confirm')}
          </Button>
        </form>
      )}
    </Formik>
  );
};
